// Only UI context belongs in the address. Session, tenant and permissions remain server-controlled.
export const APP_LOCATION_EVENT = 'rotaflex:location';
export const pageHref = page => `?page=${encodeURIComponent(page)}`;
export const readLocation = () => new URL(window.location.href);
export const locationHref = values => {
  const url = readLocation();
  Object.entries(values).forEach(([key,value]) => {
    if (value == null || value === '') url.searchParams.delete(key);
    else url.searchParams.set(key,String(value));
  });
  return `${url.pathname}${url.search}${url.hash}`;
};
export const readPage = () => readLocation().searchParams.get('page');
export const locationIndex = () => Number(window.history.state?.rotaflexIndex) || 0;
export const writeLocation = (values, { replace = false, clear = false } = {}) => {
  const url = readLocation();
  if (clear) url.search = '';
  Object.entries(values).forEach(([key, value]) => {
    if (value == null || value === '') url.searchParams.delete(key);
    else url.searchParams.set(key, String(value));
  });
  if (url.href === window.location.href) return;
  const state = { ...window.history.state, rotaflexIndex: locationIndex() + (replace ? 0 : 1) };
  window.history[replace ? 'replaceState' : 'pushState'](state, '', url);
  window.dispatchEvent(new CustomEvent(APP_LOCATION_EVENT));
};
